import apiClient from "../../client/apiClient"
import { appendQueryParams } from "../../utils"

// RMS "Reports" — bulk report-card PDF generation + parent emailing.
// (Distinct from service/reports, which is attendance monthly reports.)

export type ReportRecord = {
  id: string
  studentName: string
  grNumber: string
  breakdownTitle: string
  version: number
  isLatest: boolean
  parentEmail: string
  generatedAt: string
}

export type EmailLogRow = {
  id: string
  studentName: string
  recipientEmail: string
  subject: string
  status: string
  errorMessage: string
  sentAt: string | null
  createdAt: string
}

const BASE = "/reports"

// List generated report cards for a breakdown.
export const listReports = async (params: {
  breakdownId?: string
  isLatest?: boolean
}): Promise<{ success: boolean; items: ReportRecord[] }> => {
  const res = await apiClient({ method: "GET", url: appendQueryParams(BASE, params) })
  return res.data
}

// Generate report card PDFs for a whole breakdown (or one student).
export const generateReports = async (data: {
  breakdownId: string
  enrollmentId?: string
}): Promise<{ success: boolean; count: number; total?: number; skipped_empty?: number }> => {
  const res = await apiClient({ method: "POST", url: `${BASE}/generate`, data })
  return res.data
}

// Presigned URL to the PDF (open in a new tab).
export const getReportPdfUrl = async (id: string): Promise<{ success: boolean; url: string }> => {
  const res = await apiClient({ method: "GET", url: `${BASE}/${id}/pdf` })
  return res.data
}

// Email one report card to the parent. Whether it actually sends is governed by
// the server's IS_EMAIL_DISABLED flag; the returned log's `status` reflects it.
export const emailReport = async (
  id: string,
  recipient?: string
): Promise<{ success: boolean; data: { status: string; errorMessage?: string } }> => {
  const res = await apiClient({ method: "POST", url: `${BASE}/${id}/email`, data: { recipient } })
  return res.data
}

export const getEmailLog = async (
  status?: string
): Promise<{ success: boolean; items: EmailLogRow[] }> => {
  const res = await apiClient({ method: "GET", url: appendQueryParams(`${BASE}/email-log`, { status }) })
  return res.data
}
